import React from 'react'
import { BaseIconProps } from '../utils'

export const GuildCopperSquareIcon: React.FC<BaseIconProps> = ({ size = 24, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.26327 0.472229H14.737C15.1747 0.472229 15.5295 0.83505 15.5295 1.28493V7.71297C15.5295 11.3333 12.706 15.4063 8.00011 16.7639C3.29423 15.4063 0.470703 11.3333 0.470703 7.71297V1.28521C0.470703 0.835323 0.825549 0.472229 1.26327 0.472229Z"
        fill="url(#paint0_linear_8943_19070)"
      />
      <path
        d="M1.26327 0.472229H14.737C15.1747 0.472229 15.5295 0.83505 15.5295 1.28493V7.71297C15.5295 11.3333 12.706 15.4063 8.00011 16.7639C3.29423 15.4063 0.470703 11.3333 0.470703 7.71297V1.28521C0.470703 0.835323 0.825549 0.472229 1.26327 0.472229Z"
        fill="url(#paint1_linear_8943_19070)"
        fillOpacity="0.51"
      />
      <path
        d="M1.26327 0.472229H14.737C15.1747 0.472229 15.5295 0.83505 15.5295 1.28493V7.71297C15.5295 11.3333 12.706 15.4063 8.00011 16.7639C3.29423 15.4063 0.470703 11.3333 0.470703 7.71297V1.28521C0.470703 0.835323 0.825549 0.472229 1.26327 0.472229Z"
        fill="url(#paint2_linear_8943_19070)"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.26319 0.118042H14.7369C15.3716 0.118042 15.8824 0.636223 15.8824 1.27313V7.60801C15.8824 11.3514 12.937 15.4922 8.09624 16.8685C8.03334 16.8864 7.96672 16.8864 7.90382 16.8685C3.06303 15.4922 0.117676 11.3514 0.117676 7.60801V1.2734C0.117676 0.636648 0.628345 0.118042 1.26319 0.118042ZM8.00003 16.5278C12.7059 15.1898 15.5294 11.1759 15.5294 7.60801V1.27313C15.5294 0.829771 15.1746 0.472209 14.7369 0.472209H1.26319C0.825462 0.472209 0.470617 0.830041 0.470617 1.2734V7.60801C0.470617 11.1759 3.29415 15.1898 8.00003 16.5278Z"
        fill="url(#paint3_linear_8943_19070)"
      />
      <path
        d="M1.05002 8.43858C1.16572 12.2471 4.75247 14.827 7.5293 16.0556C6.76156 10.2126 6.75908 6.84588 7.5293 0.944458C7.5293 0.944458 1.28143 0.94461 1.05002 0.944458C0.821928 0.944308 1.01788 7.3824 1.04879 8.39788L1.05002 8.43858Z"
        fill="url(#paint4_linear_8943_19070)"
        fillOpacity="0.45"
      />
      <path
        d="M8.04282 6.94131H10.6296C10.6791 6.9452 10.7286 6.96852 10.7514 7.00738C10.7856 7.04235 10.8084 7.09287 10.8084 7.14727V10.5631C10.8084 10.5903 10.8008 10.6214 10.7894 10.6486C10.778 10.6758 10.759 10.6991 10.7362 10.7185C9.9449 11.1382 9.06233 11.3481 8.16835 11.3325C6.1141 11.282 4.4707 9.65376 4.4707 7.55531C4.4707 5.46074 6.1141 3.75089 8.16835 3.77809C9.0357 3.80529 9.99435 4.1939 10.6981 4.84675C10.7209 4.86229 10.74 4.88561 10.7514 4.90892C10.7666 4.93224 10.7742 4.95944 10.7742 4.98664C10.7742 5.01385 10.7704 5.04105 10.759 5.06825C10.7476 5.09157 10.7324 5.11488 10.7133 5.13431L9.91066 5.99312C9.86882 6.02033 9.81936 6.03587 9.76991 6.03587C9.72045 6.03587 9.671 6.02033 9.62915 5.99312C9.23732 5.60064 8.77702 5.45685 8.27867 5.44519C7.0271 5.41799 6.25105 6.39727 6.25105 7.54365C6.25105 8.70168 7.0271 9.63821 8.29009 9.66542C8.60203 9.67319 8.91017 9.62656 9.20689 9.52163V8.45686C8.97865 8.44521 8.24068 8.44521 8.03522 8.44521C8.0086 8.44521 7.98575 8.44132 7.95912 8.43355C7.9363 8.42189 7.91348 8.41023 7.89445 8.3908C7.87543 8.37137 7.86021 8.34805 7.8488 8.32474C7.83739 8.30142 7.83359 8.27422 7.83359 8.24702V7.13561C7.83359 7.10841 7.83739 7.08121 7.8488 7.05789C7.86021 7.03458 7.87543 7.01126 7.89445 6.99183C7.91348 6.9724 7.9363 6.95686 7.96293 6.94909C7.98956 6.94131 8.01619 6.93743 8.04282 6.94131Z"
        fill="url(#paint5_linear_8943_19070)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.84874 8.32477C7.83733 8.30145 7.83353 8.27425 7.83353 8.24705V7.13564C7.83353 7.10844 7.83733 7.08124 7.84874 7.05792C7.86016 7.03461 7.87538 7.01129 7.8944 6.99186C7.91342 6.97243 7.93624 6.95689 7.96287 6.94911C7.9895 6.94134 8.01613 6.93746 8.04276 6.94134H10.6296C10.679 6.94523 10.7285 6.96854 10.7513 7.00741C10.7856 7.04238 10.8084 7.0929 10.8084 7.1473V10.5631C10.8084 10.5903 10.8008 10.6214 10.7894 10.6486C10.778 10.6758 10.7589 10.6991 10.7361 10.7186C9.94484 11.1382 9.06227 11.3481 8.16829 11.3326C6.11404 11.282 4.47065 9.65379 4.47065 7.55533C4.47065 5.46077 6.11404 3.75092 8.16829 3.77812C9.03564 3.80532 9.99429 4.19392 10.6981 4.84678C10.7209 4.86232 10.7399 4.88564 10.7513 4.90895C10.7665 4.93227 10.7741 4.95947 10.7741 4.98667C10.7741 5.01387 10.7703 5.04108 10.7589 5.06828C10.7475 5.09159 10.7323 5.11491 10.7133 5.13434L9.9106 5.99315C9.86876 6.02035 9.8193 6.0359 9.76985 6.0359C9.7204 6.0359 9.67094 6.02035 9.62909 5.99315C9.23726 5.60066 8.77696 5.45688 8.27862 5.44522C7.02705 5.41802 6.251 6.3973 6.251 7.54368C6.251 8.70171 7.02704 9.63824 8.29003 9.66545C8.60197 9.67322 8.91011 9.62658 9.20683 9.52166V8.45689C8.97859 8.44523 8.24062 8.44523 8.03517 8.44523C8.00854 8.44523 7.9857 8.44135 7.95907 8.43358C7.93624 8.42192 7.91342 8.41026 7.8944 8.39083C7.87538 8.3714 7.86016 8.34808 7.84874 8.32477ZM8.97154 8.68652C8.66337 8.6814 8.19623 8.68135 8.03517 8.68135C7.98215 8.68135 7.93694 8.67301 7.89335 8.66029L7.87208 8.65408L7.85233 8.644C7.85119 8.64341 7.8499 8.64276 7.84846 8.64204C7.82694 8.63118 7.77343 8.60419 7.72654 8.55629C7.68631 8.51519 7.65754 8.4697 7.63755 8.42886C7.60414 8.36059 7.59823 8.29309 7.59823 8.24705V7.13564C7.59823 7.0896 7.60413 7.0221 7.63755 6.95383C7.65754 6.913 7.68631 6.8675 7.72654 6.8264M8.97154 8.68652V9.34823C8.75155 9.40859 8.52528 9.43512 8.29587 9.42941L8.29508 9.42939C7.72349 9.41708 7.27565 9.20076 6.96974 8.86842C6.6622 8.53431 6.48629 8.06982 6.48629 7.54368C6.48629 6.50403 7.17806 5.65757 8.27333 5.68128C8.72543 5.69189 9.12298 5.8198 9.46286 6.16026L9.48039 6.17781L9.50117 6.19132C9.57861 6.24166 9.6721 6.27201 9.76985 6.27201C9.86759 6.27201 9.96109 6.24166 10.0385 6.19132L10.0626 6.17567L10.8834 5.29747C10.9225 5.25699 10.9505 5.21244 10.9701 5.17237L10.9731 5.16621L10.9758 5.15989C11.0024 5.09659 11.0094 5.03659 11.0094 4.98667C11.0094 4.92033 10.9921 4.85257 10.956 4.79206C10.931 4.7456 10.8945 4.70014 10.8478 4.66416C10.1048 3.97959 9.09742 3.57103 8.17564 3.54212L8.17352 3.54206L8.1714 3.54203C5.97788 3.51298 4.23535 5.33745 4.23535 7.55533C4.23535 9.78543 5.98413 11.515 8.16253 11.5686L8.16422 11.5686C9.09762 11.5849 10.0194 11.3657 10.8461 10.9273L10.8688 10.9153L10.8883 10.8986C10.932 10.8614 10.9772 10.8095 11.0062 10.7402C11.0264 10.6922 11.0437 10.6296 11.0437 10.5631V7.1473C11.0437 7.0374 11.002 6.93653 10.9371 6.86146C10.8601 6.75368 10.7374 6.71298 10.648 6.70595L10.6388 6.70523H8.05571C7.99312 6.69963 7.93835 6.71038 7.89716 6.7224C7.82357 6.74388 7.76712 6.78495 7.72654 6.8264"
        fill="url(#paint6_linear_8943_19070)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8943_19070"
          x1="2.82364"
          y1="1.55035"
          x2="8.76827"
          y2="15.6097"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0439639" stopColor="#C57B46" />
          <stop offset="0.333786" stopColor="#DBA775" />
          <stop offset="0.721059" stopColor="#CC7A3D" />
          <stop offset="0.928708" stopColor="#A25A38" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8943_19070"
          x1="0.58835"
          y1="-0.366313"
          x2="2.65167"
          y2="4.75924"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0179276" stopColor="#FFFCF6" stopOpacity="0.18" />
          <stop offset="0.523139" stopColor="#FFFAEF" />
          <stop offset="0.866895" stopColor="#F8F8F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8943_19070"
          x1="9.41188"
          y1="15.8056"
          x2="6.01889"
          y2="8.66504"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0179276" stopColor="#FFFCF6" stopOpacity="0.18" />
          <stop offset="0.523139" stopColor="#FFFAEF" />
          <stop offset="0.866895" stopColor="#F8F8F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8943_19070"
          x1="7.65228"
          y1="-0.347622"
          x2="9.75645"
          y2="14.9004"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.127299" stopColor="#DDAA85" />
          <stop offset="1" stopColor="#5F3116" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_8943_19070"
          x1="2.43844"
          y1="1.68159"
          x2="7.58453"
          y2="15.494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.42" />
          <stop offset="1" stopColor="white" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_8943_19070"
          x1="5.4714"
          y1="3.90329"
          x2="9.49566"
          y2="11.2974"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0416579" stopColor="#141313" />
          <stop offset="0.594408" stopColor="#4A2B27" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_8943_19070"
          x1="8.27959"
          y1="12.0712"
          x2="5.78707"
          y2="3.03027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.127299" stopColor="#DDAA85" stopOpacity="0.4" />
          <stop offset="1" stopColor="#5F3116" />
        </linearGradient>
      </defs>
    </svg>
  )
}
